const districts = {
  "Bangkok": {
    "เขตพระนคร": "Phra Nakhon",
    "เขตดุสิต": "Dusit",
    "เขตหนองจอก": "Nong Chok",
    "เขตบางรัก": "Bang Rak",
    "เขตบางเขน": "Bang Khen",
    "เขตบางกะปิ": "Bang Kapi",
    "เขตปทุมวัน": "Pathum Wan",
    "เขตป้อมปราบศัตรูพ่าย": "Pom Prap Sattru Phai",
    "เขตพระโขนง": "Phra Khanong",
    "เขตมีนบุรี": "Min Buri",
    "เขตลาดกระบัง": "Lat Krabang",
    "เขตยานนาวา": "Yan Nawa",
    "เขตสัมพันธวงศ์": "Samphanthawong",
    "เขตพญาไท": "Phaya Thai",
    "เขตธนบุรี": "Thon Buri",
    "เขตบางกอกใหญ่": "Bangkok Yai",
    "เขตห้วยขวาง": "Huai Khwang",
    "เขตคลองสาน": "Khlong San",
    "เขตตลิ่งชัน": "Taling Chan",
    "เขตบางกอกน้อย": "Bangkok Noi",
    "เขตบางขุนเทียน": "Bang Khun Thian",
    "เขตภาษีเจริญ": "Phasi Charoen",
    "เขตหนองแขม": "Nong Khaem",
    "เขตราษฎร์บูรณะ": "Rat Burana",
    "เขตบางพลัด": "Bang Phlat",
    "เขตดินแดง": "Din Daeng",
    "เขตบึงกุ่ม": "Bueng Kum",
    "เขตสาทร": "Sathon",
    "เขตบางซื่อ": "Bang Sue",
    "เขตจตุจักร": "Chatuchak",
    "เขตบางคอแหลม": "Bang Kho Laem",
    "เขตประเวศ": "Prawet",
    "เขตคลองเตย": "Khlong Toei",
    "เขตสวนหลวง": "Suan Luang",
    "เขตจอมทอง": "Chom Thong",
    "เขตดอนเมือง": "Don Mueang",
    "เขตราชเทวี": "Ratchathewi",
    "เขตลาดพร้าว": "Lat Phrao",
    "เขตวัฒนา": "Watthana",
    "เขตบางแค": "Bang Khae",
    "เขตหลักสี่": "Lak Si",
    "เขตสายไหม": "Sai Mai",
    "เขตคันนายาว": "Khan Na Yao",
    "เขตสะพานสูง": "Saphan Sung",
    "เขตวังทองหลาง": "Wang Thonglang",
    "เขตคลองสามวา": "Khlong Sam Wa",
    "เขตบางนา": "Bang Na",
    "เขตทวีวัฒนา": "Thawi Watthana",
    "เขตทุ่งครุ": "Thung Khru",
    "เขตบางบอน": "Bang Bon"
  },
  "Samut Prakan": {
    "เมืองสมุทรปราการ": "Mueang Samut Prakan",
    "บางบ่อ": "Bang Bo",
    "บางพลี": "Bang Phli",
    "พระประแดง": "Phra Pradaeng",
    "พระสมุทรเจดีย์": "Phra Samut Chedi",
    "บางเสาธง": "Bang Sao Thong"
  },
  "Nonthaburi": {
    "เมืองนนทบุรี": "Mueang Nonthaburi",
    "บางกรวย": "Bang Kruai",
    "บางใหญ่": "Bang Yai",
    "บางบัวทอง": "Bang Bua Thong",
    "ไทรน้อย": "Sai Noi",
    "ปากเกร็ด": "Pak Kret"
  },
  "Pathum Thani": {
    "เมืองปทุมธานี": "Mueang Pathum Thani",
    "คลองหลวง": "Khlong Luang",
    "ธัญบุรี": "Thanyaburi",
    "หนองเสือ": "Nong Suea",
    "ลาดหลุมแก้ว": "Lat Lum Kaeo",
    "ลำลูกกา": "Lam Luk Ka",
    "สามโคก": "Sam Khok"
  },
  "Phra Nakhon Si Ayutthaya": {
    "พระนครศรีอยุธยา": "Phra Nakhon Si Ayutthaya",
    "ท่าเรือ": "Tha Ruea",
    "นครหลวง": "Nakhon Luang",
    "บางไทร": "Bang Sai",
    "บางบาล": "Bang Ban",
    "บางปะอิน": "Bang Pa-in",
    "บางปะหัน": "Bang Pahan",
    "ผักไห่": "Phak Hai",
    "ภาชี": "Phachi",
    "ลาดบัวหลวง": "Lat Bua Luang",
    "วังน้อย": "Wang Noi",
    "เสนา": "Sena",
    "บางซ้าย": "Bang Sai (West)",
    "อุทัย": "Uthai",
    "มหาราช": "Maha Rat",
    "บ้านแพรก": "Ban Phraek"
  },
  "Ang Thong": {
    "เมืองอ่างทอง": "Mueang Ang Thong",
    "ไชโย": "Chaiyo",
    "ป่าโมก": "Pa Mok",
    "โพธิ์ทอง": "Pho Thong",
    "แสวงหา": "Sawaeng Ha",
    "วิเศษชัยชาญ": "Wiset Chai Chan",
    "สามโก้": "Samko"
  },
  "Lopburi": {
    "เมืองลพบุรี": "Mueang Lopburi",
    "พัฒนานิคม": "Phatthana Nikhom",
    "โคกสำโรง": "Khok Samrong",
    "ชัยบาดาล": "Chai Badan",
    "ท่าวุ้ง": "Tha Wung",
    "บ้านหมี่": "Ban Mi",
    "ท่าหลวง": "Tha Luang",
    "สระโบสถ์": "Sa Bot",
    "โคกเจริญ": "Khok Charoen",
    "ลำสนธิ": "Lam Sonthi",
    "หนองม่วง": "Nong Muang"
  },
  "Sing Buri": {
    "เมืองสิงห์บุรี": "Mueang Sing Buri",
    "บางระจัน": "Bang Rachan",
    "ค่ายบางระจัน": "Khai Bang Rachan",
    "พรหมบุรี": "Phrom Buri",
    "ท่าช้าง": "Tha Chang",
    "อินทร์บุรี": "In Buri"
  },
  "Chai Nat": {
    "เมืองชัยนาท": "Mueang Chai Nat",
    "มโนรมย์": "Manorom",
    "วัดสิงห์": "Wat Sing",
    "สรรพยา": "Sapphaya",
    "สรรคบุรี": "Sankhaburi",
    "หันคา": "Hankha",
    "หนองมะโมง": "Nong Mamong",
    "เนินขาม": "Noen Kham"
  },
  "Saraburi": {
    "เมืองสระบุรี": "Mueang Saraburi",
    "แก่งคอย": "Kaeng Khoi",
    "หนองแค": "Nong Khae",
    "วิหารแดง": "Wihan Daeng",
    "หนองแซง": "Nong Saeng",
    "บ้านหมอ": "Ban Mo",
    "ดอนพุด": "Don Phut",
    "หนองโดน": "Nong Don",
    "พระพุทธบาท": "Phra Phutthabat",
    "เสาไห้": "Sao Hai",
    "มวกเหล็ก": "Muak Lek",
    "วังม่วง": "Wang Muang",
    "เฉลิมพระเกียรติ": "Chaloem Phra Kiat"
  },
  "Chon Buri": {
    "เมืองชลบุรี": "Mueang Chon Buri",
    "บ้านบึง": "Ban Bueng",
    "หนองใหญ่": "Nong Yai",
    "บางละมุง": "Bang Lamung",
    "พานทอง": "Phan Thong",
    "พนัสนิคม": "Phanat Nikhom",
    "ศรีราชา": "Si Racha",
    "เกาะสีชัง": "Ko Si Chang",
    "สัตหีบ": "Sattahip",
    "บ่อทอง": "Bo Thong",
    "เกาะจันทร์": "Ko Chan"
  },
  "Rayong": {
    "เมืองระยอง": "Mueang Rayong",
    "บ้านฉาง": "Ban Chang",
    "แกลง": "Klaeng",
    "วังจันทร์": "Wang Chan",
    "บ้านค่าย": "Ban Khai",
    "ปลวกแดง": "Pluak Daeng",
    "เขาชะเมา": "Khao Chamao",
    "นิคมพัฒนา": "Nikhom Phatthana"
  },
  "Chanthaburi": {
    "เมืองจันทบุรี": "Mueang Chanthaburi",
    "ขลุง": "Khlung",
    "ท่าใหม่": "Tha Mai",
    "โป่งน้ำร้อน": "Pong Nam Ron",
    "มะขาม": "Makham",
    "แหลมสิงห์": "Laem Sing",
    "สอยดาว": "Soi Dao",
    "แก่งหางแมว": "Kaeng Hang Maeo",
    "นายายอาม": "Na Yai Am",
    "เขาคิชฌกูฏ": "Khao Khitchakut"
  },
  "Trat": {
    "เมืองตราด": "Mueang Trat",
    "คลองใหญ่": "Khlong Yai",
    "เขาสมิง": "Khao Saming",
    "บ่อไร่": "Bo Rai",
    "แหลมงอบ": "Laem Ngop",
    "เกาะกูด": "Ko Kut",
    "เกาะช้าง": "Ko Chang"
  },
  "Chachoengsao": {
    "เมืองฉะเชิงเทรา": "Mueang Chachoengsao",
    "บางคล้า": "Bang Khla",
    "บางน้ำเปรี้ยว": "Bang Nam Priao",
    "บางปะกง": "Bang Pakong",
    "บ้านโพธิ์": "Ban Pho",
    "พนมสารคาม": "Phanom Sarakham",
    "ราชสาส์น": "Ratchasan",
    "สนามชัยเขต": "Sanam Chai Khet",
    "แปลงยาว": "Plaeng Yao",
    "ท่าตะเกียบ": "Tha Takiap",
    "คลองเขื่อน": "Khlong Khuean"
  },
  "Prachin Buri": {
    "เมืองปราจีนบุรี": "Mueang Prachin Buri",
    "กบินทร์บุรี": "Kabin Buri",
    "นาดี": "Na Di",
    "บ้านสร้าง": "Ban Sang",
    "ประจันตคาม": "Prachin Takham",
    "ศรีมหาโพธิ": "Si Maha Phot",
    "ศรีมโหสถ": "Si Mahosot"
  },
  "Nakhon Nayok": {
    "เมืองนครนายก": "Mueang Nakhon Nayok",
    "ปากพลี": "Pak Phli",
    "บ้านนา": "Ban Na",
    "องครักษ์": "Ongkharak"
  },
  "Sa Kaeo": {
    "เมืองสระแก้ว": "Mueang Sa Kaeo",
    "คลองหาด": "Khlong Hat",
    "ตาพระยา": "Ta Phraya",
    "วังน้ำเย็น": "Wang Nam Yen",
    "วัฒนานคร": "Watthana Nakhon",
    "อรัญประเทศ": "Aranyaprathet",
    "เขาฉกรรจ์": "Khao Chakan",
    "โคกสูง": "Khok Sung",
    "วังสมบูรณ์": "Wang Sombun"
  },
  "Nakhon Ratchasima": {
    "เมืองนครราชสีมา": "Mueang Nakhon Ratchasima",
    "ครบุรี": "Khon Buri",
    "เสิงสาง": "Soeng Sang",
    "คง": "Khong",
    "บ้านเหลื่อม": "Ban Lueam",
    "จักราช": "Chakkarat",
    "โชคชัย": "Chok Chai",
    "ด่านขุนทด": "Dan Khun Thot",
    "โนนไทย": "Non Thai",
    "โนนสูง": "Non Sung",
    "ขามสะแกแสง": "Kham Sakae Saeng",
    "บัวใหญ่": "Bua Yai",
    "ประทาย": "Prathai",
    "ปักธงชัย": "Pak Thong Chai",
    "พิมาย": "Phimai",
    "ห้วยแถลง": "Huai Thalaeng",
    "ชุมพวง": "Chum Phuang",
    "สูงเนิน": "Sung Noen",
    "ขามทะเลสอ": "Kham Thale So",
    "สีคิ้ว": "Si Khio",
    "ปากช่อง": "Pak Chong",
    "หนองบุญมาก": "Nong Bun Mak",
    "แก้งสนามนาง": "Kaeng Sanam Nang",
    "โนนแดง": "Non Daeng",
    "วังน้ำเขียว": "Wang Nam Khiao",
    "เทพารักษ์": "Thepharak",
    "เมืองยาง": "Mueang Yang",
    "พระทองคำ": "Phra Thong Kham",
    "ลำทะเมนชัย": "Lam Thamenchai",
    "บัวลาย": "Bua Lai",
    "สีดา": "Si Da",
    "เฉลิมพระเกียรติ": "Chaloem Phra Kiat"
  },
  "Buriram": {
    "เมืองบุรีรัมย์": "Mueang Buriram",
    "คูเมือง": "Khù Mueang",
    "กระสัง": "Krasang",
    "นางรอง": "Nang Rong",
    "หนองกี่": "Nong Ki",
    "ละหานทราย": "Lahan Sai",
    "ประโคนชัย": "Prakhon Chai",
    "บ้านกรวด": "Ban Kruat",
    "พุทไธสง": "Phutthaisong",
    "ลำปลายมาศ": "Lam Plai Mat",
    "สตึก": "Satuek",
    "ปะคำ": "Pakham",
    "นาโพธิ์": "Na Pho",
    "หนองหงส์": "Nong Hong",
    "พลับพลาชัย": "Phlapphla Chai",
    "ห้วยราช": "Huai Rat",
    "โนนสุวรรณ": "Non Suwan",
    "ชำนิ": "Chumphon Buri",
    "บ้านใหม่ไชยพจน์": "Ban Mai Chaiyaphot",
    "โนนดินแดง": "Non Din Daeng",
    "บ้านด่าน": "Ban Dan",
    "แคนดง": "Khaen Dong",
    "เฉลิมพระเกียรติ": "Chaloem Phra Kiat"
  },
  "Surin": {
    "เมืองสุรินทร์": "Mueang Surin",
    "ชุมพลบุรี": "Chumphon Buri",
    "ท่าตูม": "Tha Tum",
    "จอมพระ": "Chom Phra",
    "ปราสาท": "Prasat",
    "กาบเชิง": "Kap Choeng",
    "รัตนบุรี": "Rattanaburi",
    "สนม": "Sanom",
    "ศีขรภูมิ": "Sikhio Phum",
    "สังขะ": "Sangkha",
    "ลำดวน": "Lamduan",
    "สำโรงทาบ": "Samrong Thap",
    "บัวเชด": "Buachet",
    "พนมดงรัก": "Phanom Dong Rak",
    "ศรีณรงค์": "Si Narong",
    "เขวาสินรินทร์": "Khwao Sinarin",
    "โนนนารายณ์": "Non Narai"
  },
  "Si Sa Ket": {
    "เมืองศรีสะเกษ": "Mueang Si Sa Ket",
    "ยางชุมน้อย": "Yang Chum Noi",
    "กันทรารมย์": "Kanthararom",
    "กันทรลักษ์": "Kantharalak",
    "ขุขันธ์": "Khukhan",
    "ไพรบึง": "Phrai Bueng",
    "ปรางค์กู่": "Prang Ku",
    "ขุนหาญ": "Khun Han",
    "ราษีไศล": "Rasi Salai",
    "อุทุมพรพิสัย": "Uthumphon Phisai",
    "บึงบูรพ์": "Bueng Burapha",
    "ห้วยทับทัน": "Huai Thap Than",
    "โนนคูณ": "Non Khun",
    "ศรีรัตนะ": "Si Rattana",
    "น้ำเกลี้ยง": "Nam Kliang",
    "วังหิน": "Wang Hin",
    "ภูสิงห์": "Phu Sing",
    "เมืองจันทร์": "Mueang Chan",
    "เบญจลักษ์": "Benchalak",
    "พยุห์": "Phayu",
    "โพธิ์ศรีสุวรรณ": "Pho Si Suwan",
    "ศิลาลาด": "Si La Lat"
  },
  "Ubon Ratchathani": {
    "เมืองอุบลราชธานี": "Mueang Ubon Ratchathani",
    "ศรีเมืองใหม่": "Sri Muang Mai",
    "โขงเจียม": "Khong Chiam",
    "เขื่องใน": "Khueang Nai",
    "เขมราฐ": "Khemarat",
    "เดชอุดม": "Det Udom",
    "นาจะหลวย": "Na Chaluai",
    "น้ำยืน": "Nam Yuen",
    "บุณฑริก": "Buntharik",
    "ตระการพืชผล": "Trakan Phuet Phon",
    "กุดข้าวปุ้น": "Kut Khaopun",
    "ม่วงสามสิบ": "Muang Sam Sip",
    "วารินชำราบ": "Warin Chamrap",
    "พิบูลมังสาหาร": "Phibun Mangsahan",
    "ตาลสุม": "Tan Sum",
    "โพธิ์ไทร": "Pho Sai",
    "สำโรง": "Samrong",
    "ดอนมดแดง": "Don Mot Daeng",
    "สิรินธร": "Sirindhorn",
    "ทุ่งศรีอุดม": "Thung Si Udom",
    "นาเยีย": "Na Yia",
    "นาตาล": "Na Tan",
    "เหล่าเสือโก้ก": "Lao Suea Kok",
    "สว่างวีระวงศ์": "Sawang Wirawong",
    "น้ำขุ่น": "Nam Khun"
  },
  "Yasothon": {
    "เมืองยโสธร": "Mueang Yasothon",
    "ทรายมูล": "Sai Mun",
    "กุดชุม": "Kut Chum",
    "คำเขื่อนแก้ว": "Kham Khuean Kaeo",
    "ป่าติ้ว": "Pa Tio",
    "มหาชนะชัย": "Maha Chana Chai",
    "ค้อวัง": "Kho Wang",
    "เลิงนกทา": "Loeng Nok Tha",
    "ไทยเจริญ": "Thai Charoen"
  },
  "Chaiyaphum": {
    "เมืองชัยภูมิ": "Mueang Chaiyaphum",
    "บ้านเขว้า": "Ban Khwao",
    "คอนสวรรค์": "Khon Sawan",
    "เกษตรสมบูรณ์": "Kaset Sombun",
    "หนองบัวแดง": "Nong Bua Daeng",
    "จัตุรัส": "Chatturat",
    "บำเหน็จณรงค์": "Bamnet Narong",
    "หนองบัวระเหว": "Nong Bua Rawe",
    "เทพสถิต": "Thep Sathit",
    "ภูเขียว": "Phu Khiao",
    "บ้านแท่น": "Ban Thaen",
    "แก้งคร้อ": "Kaeng Khro",
    "คอนสาร": "Khon San",
    "ภักดีชุมพล": "Phakdi Chumphon",
    "เนินสง่า": "Noen Sa Nga",
    "ซับใหญ่": "Sap Yai"
  },
  "Amnat Charoen": {
    "เมืองอำนาจเจริญ": "Mueang Amnat Charoen",
    "ชานุมาน": "Chanuman",
    "ปทุมราชวงศา": "Pathum Ratchawongsa",
    "พนา": "Phana",
    "เสนางคนิคม": "Senangkhanikhom",
    "หัวตะพาน": "Hua Taphan",
    "ลืออำนาจ": "Lue Amnat"
  },
  "Bueng Kan": {
    "เมืองบึงกาฬ": "Mueang Bueng Kan",
    "เซกา": "Seka",
    "โซ่พิสัย": "So Phisai",
    "พรเจริญ": "Phon Charoen",
    "ศรีวิไล": "Si Wilai",
    "บึงโขงหลง": "Bueng Khong Long",
    "ปากคาด": "Pak Khat",
    "บุ่งคล้า": "Bung Khla"
  },
  "Nong Bua Lamphu": {
    "เมืองหนองบัวลำภู": "Mueang Nong Bua Lamphu",
    "นากลาง": "Na Klang",
    "โนนสัง": "Non Sang",
    "ศรีบุญเรือง": "Si Bun Rueang",
    "สุวรรณคูหา": "Suwan Khuha",
    "นาวัง": "Na Wang"
  },
  "Khon Kaen": {
    "เมืองขอนแก่น": "Mueang Khon Kaen",
    "บ้านฝาง": "Ban Fang",
    "พระยืน": "Phra Yuen",
    "หนองเรือ": "Nong Ruea",
    "ชุมแพ": "Chum Phae",
    "สีชมพู": "Si Chomphu",
    "น้ำพอง": "Nam Phong",
    "อุบลรัตน์": "Ubolratana",
    "กระนวน": "Khranuan",
    "บ้านไผ่": "Ban Phai",
    "เปือยน้อย": "Puea Noi",
    "พล": "Phon",
    "แวงใหญ่": "Waeng Yai",
    "แวงน้อย": "Waeng Noi",
    "หนองสองห้อง": "Nong Song Hong",
    "ภูเวียง": "Phu Wiang",
    "มัญจาคีรี": "Manchakhiri",
    "ชนบท": "Chonnabot",
    "เขาสวนกวาง": "Khao Suan Kwang",
    "ภูผาม่าน": "Phu Pha Man",
    "ซำสูง": "Sam Sung",
    "โคกโพธิ์ไชย": "Khok Pho Chai",
    "หนองนาคำ": "Nong Na Kham",
    "บ้านแฮด": "Ban Haet",
    "โนนศิลา": "Non Sila",
    "เวียงเก่า": "Wiang Kao"
  },
  "Udon Thani": {
    "เมืองอุดรธานี": "Mueang Udon Thani",
    "กุดจับ": "Kut Chap",
    "หนองวัวซอ": "Nong Wua So",
    "กุมภวาปี": "Kumphawapi",
    "โนนสะอาด": "Non Sa-at",
    "หนองหาน": "Nong Han",
    "ทุ่งฝน": "Thung Fon",
    "ไชยวาน": "Chai Wan",
    "ศรีธาตุ": "Si That",
    "วังสามหมอ": "Wang Sam Mo",
    "บ้านดุง": "Ban Dung",
    "บ้านผือ": "Ban Phue",
    "น้ำโสม": "Nam Som",
    "เพ็ญ": "Phen",
    "สร้างคอม": "Sang Khom",
    "หนองแสง": "Nong Saeng",
    "นายูง": "Nai Uong",
    "พิบูลย์รักษ์": "Phibun Rak",
    "กู่แก้ว": "Ku Kaeo",
    "ประจักษ์ศิลปาคม": "Prachak Silpakhom"
  },
  "Loei": {
    "เมืองเลย": "Mueang Loei",
    "นาด้วง": "Na Duang",
    "เชียงคาน": "Chiang Khan",
    "ปากชม": "Pak Chom",
    "ด่านซ้าย": "Dan Sai",
    "นาแห้ว": "Na Haeo",
    "ภูเรือ": "Phu Ruea",
    "ท่าลี่": "Tha Li",
    "วังสะพุง": "Wang Saphung",
    "ภูกระดึง": "Phu Kradueng",
    "ภูหลวง": "Phu Luang",
    "ผาขาว": "Pha Khao",
    "เอราวัณ": "Erawan",
    "หนองหิน": "Nong Hin"
  },
  "Nong Khai": {
    "เมืองหนองคาย": "Mueang Nong Khai",
    "ท่าบ่อ": "Tha Bo",
    "โพนพิสัย": "Phon Phisai",
    "ศรีเชียงใหม่": "Si Chiang Mai",
    "สังคม": "Sangkhom",
    "สระใคร": "Sa Khrai",
    "เฝ้าไร่": "Fao Rai",
    "รัตนวาปี": "Rattanawapi",
    "โพธิ์ตาก": "Pho Tak"
  },
  "Maha Sarakham": {
    "เมืองมหาสารคาม": "Mueang Maha Sarakham",
    "แกดำ": "Kae Dam",
    "โกสุมพิสัย": "Kosum Phisai",
    "กันทรวิชัย": "Kantharawichai",
    "เชียงยืน": "Chiang Yuen",
    "บรบือ": "Borabu",
    "นาเชือก": "Na Chueak",
    "พยัคฆภูมิพิสัย": "Phayakkhaphum Phisai",
    "วาปีปทุม": "Wapi Pathum",
    "นาดูน": "Na Dun",
    "ยางสีสุราช": "Yang Sisurat",
    "กุดรัง": "Kut Rang",
    "ชื่นชม": "Chuen Chom"
  },
  "Roi Et": {
    "เมืองร้อยเอ็ด": "Mueang Roi Et",
    "เกษตรวิสัย": "Kaset Wisai",
    "ปทุมรัตต์": "Pathum Rat",
    "จตุรพักตรพิมาน": "Chaturaphak Phiman",
    "ธวัชบุรี": "Thawat Buri",
    "พนมไพร": "Phanom Phrai",
    "โพนทอง": "Phon Thong",
    "โพธิ์ชัย": "Pho Chai",
    "หนองพอก": "Nong Phok",
    "เสลภูมิ": "Sila Phum",
    "สุวรรณภูมิ": "Suwannaphum",
    "เมืองสรวง": "Mueang Suang",
    "โพนทราย": "Phon Sai",
    "อาจสามารถ": "At Samat",
    "เมยวดี": "Muey Wadi",
    "ศรีสมเด็จ": "Si Somdet",
    "จังหาร": "Changhan",
    "เชียงขวัญ": "Chiang Khwan",
    "หนองฮี": "Nong Hi",
    "ทุ่งเขาหลวง": "Thung Khon Luang"
  },
  "Kalasin": {
    "เมืองกาฬสินธุ์": "Mueang Kalasin",
    "นามน": "Na Mon",
    "กมลาไสย": "Kamalasai",
    "ร่องคำ": "Rong Kham",
    "กุฉินารายณ์": "Kuchinarai",
    "เขาวง": "Khao Wong",
    "ยางตลาด": "Yang Talat",
    "ห้วยเม็ก": "Huai Mek",
    "สหัสขันธ์": "Sahatsakhan",
    "คำม่วง": "Kham Muang",
    "ท่าคันโท": "Tha Khantho",
    "หนองกุงศรี": "Nong Kung Si",
    "สมเด็จ": "Somdet",
    "ห้วยผึ้ง": "Huai Phueng",
    "สามชัย": "Sam Chai",
    "นาคู": "Na Khu",
    "ดอนจาน": "Don Chaan",
    "ฆ้องชัย": "Khong Chai"
  },
  "Sakon Nakhon": {
    "เมืองสกลนคร": "Mueang Sakon Nakhon",
    "กุสุมาลย์": "Kusuman",
    "กุดบาก": "Kut Bak",
    "พรรณานิคม": "Phanna Nikhom",
    "พังโคน": "Phang Khon",
    "วาริชภูมิ": "Waritchaphum",
    "นิคมน้ำอูน": "Nikhom Nam Un",
    "วานรนิวาส": "Wanon Niwat",
    "คำตากล้า": "Kham Ta Kla",
    "บ้านม่วง": "Ban Muang",
    "อากาศอำนวย": "Akat Amnuai",
    "สว่างแดนดิน": "Sawang Daen Din",
    "ส่องดาว": "Song Dao",
    "เต่างอย": "Ta Oi",
    "โคกศรีสุพรรณ": "Khok Si Suphan",
    "เจริญศิลป์": "Charoen Sin",
    "โพนนาแก้ว": "Phon Na Kaeo",
    "ภูพาน": "Phu Phan"
  },
  "Nakhon Phanom": {
    "เมืองนครพนม": "Mueang Nakhon Phanom",
    "ปลาปาก": "Pla Pak",
    "ท่าอุเทน": "Tha Uthen",
    "บ้านแพง": "Ban Phaeng",
    "ธาตุพนม": "That Phanom",
    "เรณูนคร": "Renu Nakhon",
    "นาแก": "Na Kae",
    "ศรีสงคราม": "Si Sangkhram",
    "นาหว้า": "Na Wa",
    "โพนสวรรค์": "Phon Sawan",
    "นาทม": "Na Thom",
    "วังยาง": "Wang Yang"
  },
  "Mukdahan": {
    "เมืองมุกดาหาร": "Mueang Mukdahan",
    "นิคมคำสร้อย": "Nikhom Kham Soi",
    "ดอนตาล": "Don Tan",
    "ดงหลวง": "Dong Luang",
    "คำชะอี": "Kham Cha-i",
    "หว้านใหญ่": "Wan Yai",
    "หนองสูง": "Nong Sung"
  },
  "Chiang Mai": {
    "เมืองเชียงใหม่": "Mueang Chiang Mai",
    "จอมทอง": "Chom Thong",
    "แม่แจ่ม": "Mae Chaem",
    "เชียงดาว": "Chiang Dao",
    "ดอยสะเก็ด": "Doi Saket",
    "แม่แตง": "Mae Taeng",
    "แม่ริม": "Mae Rim",
    "สะเมิง": "Samoeng",
    "ฝาง": "Fang",
    "แม่อาย": "Mae Ai",
    "พร้าว": "Phrao",
    "สันป่าตอง": "San Pa Tong",
    "สันกำแพง": "San Kamphaeng",
    "สันทราย": "San Sai",
    "หางดง": "Hang Dong",
    "ฮอด": "Hod",
    "ดอยเต่า": "Doi Tao",
    "อมก๋อย": "Omkoi",
    "สารภี": "Saraphi",
    "เวียงแหง": "Wiang Haeng",
    "ไชยปราการ": "Chai Prakan",
    "แม่วาง": "Mae Wang",
    "แม่ออน": "Mae On",
    "ดอยหล่อ": "Doi Lo"
  },
  "Lamphun": {
    "เมืองลำพูน": "Mueang Lamphun",
    "แม่ทา": "Mae Tha",
    "บ้านโฮ่ง": "Ban Hong",
    "ลี้": "Li",
    "ทุ่งหัวช้าง": "Thung Hua Chang",
    "ป่าซาง": "Pa Sang",
    "บ้านธิ": "Ban Thi",
    "เวียงหนองล่อง": "Wiang Nong Long"
  },
  "Lampang": {
    "เมืองลำปาง": "Mueang Lampang",
    "แม่เมาะ": "Mae Mo",
    "เกาะคา": "Ko Kha",
    "เสริมงาม": "Soem Ngam",
    "งาว": "Ngao",
    "แจ้ห่ม": "Chae Hom",
    "วังเหนือ": "Wang Nuea",
    "เถิน": "Thoen",
    "แม่พริก": "Mae Phrik",
    "แม่ทะ": "Mae Tha",
    "สบปราบ": "Sop Prap",
    "ห้างฉัตร": "Hang Chat",
    "เมืองปาน": "Mueang Pan"
  },
  "Uttaradit": {
    "เมืองอุตรดิตถ์": "Mueang Uttaradit",
    "ตรอน": "Tron",
    "ท่าปลา": "Tha Pla",
    "น้ำปาด": "Nam Pat",
    "ฟากท่า": "Fak Tha",
    "บ้านโคก": "Ban Khok",
    "พิชัย": "Pichai",
    "ลับแล": "Laplae",
    "ทองแสนขัน": "Thong Saen Khan"
  },
  "Phrae": {
    "เมืองแพร่": "Mueang Phrae",
    "ร้องกวาง": "Rong Kwang",
    "ลอง": "Long",
    "สูงเม่น": "Sung Men",
    "เด่นชัย": "Den Chai",
    "สอง": "Song",
    "วังชิ้น": "Wang Chin",
    "หนองม่วงไข่": "Nong Muang Khai"
  },
  "Nan": {
    "เมืองน่าน": "Mueang Nan",
    "แม่จริม": "Mae Charim",
    "บ้านหลวง": "Ban Luang",
    "นาน้อย": "Na Noi",
    "ปัว": "Pua",
    "ท่าวังผา": "Tha Wang Pha",
    "เวียงสา": "Wiang Sa",
    "ทุ่งช้าง": "Thung Chang",
    "เชียงกลาง": "Chiang Klang",
    "นาหมื่น": "Na Muen",
    "สันติสุข": "San Tikhu",
    "บ่อเกลือ": "Bo Kluea",
    "สองแคว": "Song Khwae",
    "ภูเพียง": "Phu Phiang",
    "เฉลิมพระเกียรติ": "Chaloem Phra Kiat"
  },
    "Phayao": {
    "เมืองพะเยา": "Mueang Phayao",
    "จุน": "Chun",
    "เชียงคำ": "Chiang Kham",
    "เชียงม่วน": "Chiang Muan",
    "ดอกคำใต้": "Dok Kham Tai",
    "ปง": "Pong",
    "แม่ใจ": "Mae Chai",
    "ภูซาง": "Phu Sang",
    "ภูกามยาว": "Phu Kam Yao"
  },
  "Chiang Rai": {
    "เมืองเชียงราย": "Mueang Chiang Rai",
    "เวียงชัย": "Wiang Chai",
    "เชียงของ": "Chiang Khong",
    "เทิง": "Thoeng",
    "พาน": "Phan",
    "ป่าแดด": "Pa Daet",
    "แม่จัน": "Mae Chan",
    "เชียงแสน": "Chiang Saen",
    "แม่สาย": "Mae Sai",
    "แม่สรวย": "Mae Suai",
    "เวียงป่าเป้า": "Wiang Pa Pao",
    "พญาเม็งราย": "Phaya Mengrai",
    "เวียงแก่น": "Wiang Kaen",
    "ขุนตาล": "Khun Tan",
    "แม่ฟ้าหลวง": "Mae Fa Luang",
    "แม่ลาว": "Mae Lao",
    "เวียงเชียงรุ้ง": "Wiang Chiang Rung",
    "ดอยหลวง": "Doi Luang"
  },
  "Mae Hong Son": {
    "เมืองแม่ฮ่องสอน": "Mueang Mae Hong Son",
    "ขุนยวม": "Khun Yuam",
    "ปาย": "Pai",
    "แม่สะเรียง": "Mae Sariang",
    "แม่ลาน้อย": "Mae La Noi",
    "สบเมย": "Sop Moei",
    "ปางมะผ้า": "Pang Mapha"
  },
  "Nakhon Sawan": {
    "เมืองนครสวรรค์": "Mueang Nakhon Sawan",
    "โกรกพระ": "Krok Phra",
    "ชุมแสง": "Chum Saeng",
    "หนองบัว": "Nong Bua",
    "บรรพตพิสัย": "Banphot Phisai",
    "เก้าเลี้ยว": "Kao Liao",
    "ตาคลี": "Takli",
    "ท่าตะโก": "Tha Tako",
    "ไพศาลี": "Phaisali",
    "พยุหะคีรี": "Phayuha Khiri",
    "ลาดยาว": "Lat Yao",
    "ตากฟ้า": "Tak Fa",
    "แม่วงก์": "Mae Wong",
    "แม่เปิน": "Mae Poen",
    "ชุมตาบง": "Chum Ta Bong"
  },
  "Uthai Thani": {
    "เมืองอุทัยธานี": "Mueang Uthai Thani",
    "ทัพทัน": "Thap Than",
    "สว่างอารมณ์": "Sawang Arom",
    "หนองฉาง": "Nong Chang",
    "หนองขาหย่าง": "Nong Khayang",
    "บ้านไร่": "Ban Rai",
    "ลานสัก": "Lan Sak",
    "ห้วยคต": "Huai Khot"
  },
  "Kamphaeng Phet": {
    "เมืองกำแพงเพชร": "Mueang Kamphaeng Phet",
    "ไทรงาม": "Sai Ngam",
    "คลองลาน": "Khlong Lan",
    "ขาณุวรลักษบุรี": "Khanu Woralaksaburi",
    "คลองขลุง": "Khlong Khlung",
    "พรานกระต่าย": "Phran Kratai",
    "ลานกระบือ": "Lan Krabue",
    "ทรายทองวัฒนา": "Sai Thong Watthana",
    "ปางศิลาทอง": "Pang Sila Thong",
    "บึงสามัคคี": "Bueng Samakkhi",
    "โกสัมพีนคร": "Kosamphi Nakhon"
  },
  "Tak": {
    "เมืองตาก": "Mueang Tak",
    "บ้านตาก": "Ban Tak",
    "สามเงา": "Sam Ngao",
    "แม่ระมาด": "Mae Ramat",
    "ท่าสองยาง": "Tha Song Yang",
    "แม่สอด": "Mae Sot",
    "พบพระ": "Phob Phra",
    "อุ้มผาง": "Umphang",
    "วังเจ้า": "Wang Chao"
  },
  "Sukhothai": {
    "เมืองสุโขทัย": "Mueang Sukhothai",
    "บ้านด่านลานหอย": "Ban Dan Lan Hoi",
    "คีรีมาศ": "Khiri Mat",
    "กงไกรลาศ": "Kong Krailat",
    "ศรีสัชนาลัย": "Si Satchanalai",
    "ศรีสำโรง": "Si Samrong",
    "สวรรคโลก": "Sawang Aromrak",
    "ศรีนคร": "Si Nakhon",
    "ทุ่งเสลี่ยม": "Thung Saliam"
  },
  "Phitsanulok": {
    "เมืองพิษณุโลก": "Mueang Phitsanulok",
    "นครไทย": "Nakhon Thai",
    "ชาติตระการ": "Chat Trakan",
    "บางระกำ": "Bang Rakam",
    "บางกระทุ่ม": "Bang Krathum",
    "พรหมพิราม": "Phrom Phiram",
    "วัดโบสถ์": "Wat Bot",
    "วังทอง": "Wang Thong",
    "เนินมะปราง": "Noen Maprang"
  },
  "Phichit": {
    "เมืองพิจิตร": "Mueang Phichit",
    "วังทรายพูน": "Wang Sai Phun",
    "โพธิ์ประทับช้าง": "Pho Phrathep Chang",
    "ตะพานหิน": "Taphan Hin",
    "บางมูลนาก": "Bang Mun Nak",
    "โพทะเล": "Pho Thale",
    "สามง่าม": "Sam Ngam",
    "ทับคล้อ": "Thap Khlo",
    "สากเหล็ก": "Sak Lek",
    "บึงนาราง": "Bueng Na Rang",
    "ดงเจริญ": "Dong Charoen",
    "วชิรบารมี": "Wachirabarami"
  },
  "Phetchabun": {
    "เมืองเพชรบูรณ์": "Mueang Phetchabun",
    "ชนแดน": "Chon Daen",
    "หล่มสัก": "Lom Sak",
    "หล่มเก่า": "Lom Kao",
    "วิเชียรบุรี": "Wichian Buri",
    "ศรีเทพ": "Si Thep",
    "หนองไผ่": "Nong Phai",
    "บึงสามพัน": "Bueng Sam Phan",
    "น้ำหนาว": "Nam Nao",
    "วังโป่ง": "Wang Pong",
    "เขาค้อ": "Khao Kho"
  },
  "Ratchaburi": {
    "เมืองราชบุรี": "Mueang Ratchaburi",
    "จอมบึง": "Chom Bueng",
    "สวนผึ้ง": "Suan Phueng",
    "ดำเนินสะดวก": "Damnoen Saduak",
    "บ้านโป่ง": "Ban Pong",
    "บางแพ": "Bang Phae",
    "โพธาราม": "Photharam",
    "ปากท่อ": "Pak Tho",
    "วัดเพลง": "Wat Phleng",
    "บ้านคา": "Ban Kha",
    "ท้องถิ่นเทศบาลตำบลบ้านฆ้อง": "Ban Khong"
  },
  "Kanchanaburi": {
    "เมืองกาญจนบุรี": "Mueang Kanchanaburi",
    "ไทรโยค": "Sai Yok",
    "บ่อพลอย": "Bo Phloi",
    "ศรีสวัสดิ์": "Si Sawat",
    "ท่ามะกา": "Tha Maka",
    "ท่าม่วง": "Tha Muang",
    "ทองผาภูมิ": "Thong Pha Phum",
    "สังขละบุรี": "Sangkhla Buri",
    "พนมทวน": "Phanom Thuan",
    "เลาขวัญ": "Lae Chanuan",
    "ด่านมะขามเตี้ย": "Dan Makham Tia",
    "หนองปรือ": "Nong Prue",
    "ห้วยกระเจา": "Huai Krachao"
  },
  "Suphan Buri": {
    "เมืองสุพรรณบุรี": "Mueang Suphan Buri",
    "เดิมบางนางบวช": "Doem Bang Nang Buat",
    "ด่านช้าง": "Dan Chang",
    "บางปลาม้า": "Bang Pla Ma",
    "ศรีประจันต์": "Si Prachan",
    "ดอนเจดีย์": "Don Chedi",
    "สองพี่น้อง": "Song Phi Nong",
    "สามชุก": "Sam Chuk",
    "อู่ทอง": "U Thong",
    "หนองหญ้าไซ": "Nong Ya Sai"
  },
  "Nakhon Pathom": {
    "เมืองนครปฐม": "Mueang Nakhon Pathom",
    "กำแพงแสน": "Kamphaeng Saen",
    "นครชัยศรี": "Nakhon Chai Si",
    "ดอนตูม": "Don Tum",
    "บางเลน": "Bang Len",
    "สามพราน": "Sam Phran",
    "พุทธมณฑล": "Phutthamonthon"
  },
  "Samut Sakhon": {
    "เมืองสมุทรสาคร": "Mueang Samut Sakhon",
    "กระทุ่มแบน": "Krathum Baen",
    "บ้านแพ้ว": "Ban Phaeo"
  },
  "Samut Songkhram": {
    "เมืองสมุทรสงคราม": "Mueang Samut Songkhram",
    "บางคนที": "Bang Khonthi",
    "อัมพวา": "Amphawa"
  },
  "Phetchaburi": {
    "เมืองเพชรบุรี": "Mueang Phetchaburi",
    "เขาย้อย": "Khao Yoi",
    "หนองหญ้าปล้อง": "Nong Ya Plong",
    "ชะอำ": "Cha-am",
    "ท่ายาง": "Tha Yang",
    "บ้านลาด": "Ban Lat",
    "บ้านแหลม": "Ban Laem",
    "แก่งกระจาน": "Kaeng Krachan"
  },
  "Prachuap Khiri Khan": {
    "เมืองประจวบคีรีขันธ์": "Mueang Prachuap Khiri Khan",
    "กุยบุรี": "Kui Buri",
    "ทับสะแก": "Thap Sakae",
    "บางสะพาน": "Bang Saphan",
    "บางสะพานน้อย": "Bang Saphan Noi",
    "ปราณบุรี": "Pran Buri",
    "หัวหิน": "Hua Hin",
    "สามร้อยยอด": "Sam Roi Yot"
  },
  "Nakhon Si Thammarat": {
    "เมืองนครศรีธรรมราช": "Mueang Nakhon Si Thammarat",
    "พรหมคีรี": "Phrom Khiri",
    "ลานสกา": "Lan Saka",
    "ฉวาง": "Chawang",
    "พิปูน": "Phipun",
    "เชียรใหญ่": "Chian Yai",
    "ชะอวด": "Cha-uat",
    "ท่าศาลา": "Tha Sala",
    "ทุ่งสง": "Thung Song",
    "นาบอน": "Na Bon",
    "ทุ่งใหญ่": "Thung Yai",
    "ปากพนัง": "Pak Phanang",
    "ร่อนพิบูลย์": "Ron Phibun",
    "สิชล": "Sichon",
    "ขนอม": "Khanom",
    "หัวไทร": "Hua Sai",
    "บางขัน": "Bang Khan",
    "ถ้ำพรรณรา": "Tham Phannara",
    "จุฬาภรณ์": "Chulabhorn",
    "พระพรหม": "Phra Phrom",
    "นบพิตำ": "Nopphitam",
    "ช้างกลาง": "Chang Klang",
    "เฉลิมพระเกียรติ": "Chaloem Phra Kiat"
  },
  "Krabi": {
    "เมืองกระบี่": "Mueang Krabi",
    "เขาพนม": "Khao Phanom",
    "เกาะลันตา": "Ko Lanta",
    "คลองท่อม": "Khlong Thom",
    "อ่าวลึก": "Ao Luek",
    "ปลายพระยา": "Plai Phraya",
    "ลำทับ": "Lam Thap",
    "เหนือคลอง": "Nua Khlong"
  },
  "Phang Nga": {
    "เมืองพังงา": "Mueang Phang Nga",
    "เกาะยาว": "Ko Yao",
    "กะปง": "Kapong",
    "ตะกั่วทุ่ง": "Ta Ku Thung",
    "ตะกั่วป่า": "Ta Kua Pa",
    "คุระบุรี": "Khura Buri",
    "ทับปุด": "Thap Phut",
    "ท้ายเหมือง": "Thai Mueang"
  },
  "Phuket": {
    "เมืองภูเก็ต": "Mueang Phuket",
    "กะทู้": "Kathu",
    "ถลาง": "Thalang"
  },
  "Surat Thani": {
    "เมืองสุราษฎร์ธานี": "Mueang Surat Thani",
    "กาญจนดิษฐ์": "Kanchanadit",
    "ดอนสัก": "Don Sak",
    "เกาะสมุย": "Ko Samui",
    "เกาะพะงัน": "Ko Pha-ngan",
    "ไชยา": "Chaiya",
    "ท่าชนะ": "Tha Chana",
    "คีรีรัฐนิคม": "Khiri Rat Nikhom",
    "บ้านตาขุน": "Ban Ta Khun",
    "พนม": "Phanom",
    "ท่าฉาง": "Tha Chang",
    "บ้านนาสาร": "Ban Na San",
    "บ้านนาเดิม": "Ban Na Doem",
    "เคียนซา": "Khian Sa",
    "เวียงสระ": "Wiang Sa",
    "พระแสง": "Phra Saeng",
    "พุนพิน": "Phunphin",
    "ชัยบุรี": "Chai Buri",
    "วิภาวดี": "Wiphawadi"
  },
  "Ranong": {
    "เมืองระนอง": "Mueang Ranong",
    "ละอุ่น": "La-un",
    "กะเปอร์": "Kapoe",
    "กระบุรี": "Kra Buri",
    "สุขสำราญ": "Suk Samran"
  },
  "Chumphon": {
    "เมืองชุมพร": "Mueang Chumphon",
    "ท่าแซะ": "Tha Sae",
    "ปะทิว": "Pathio",
    "หลังสวน": "Lang Suan",
    "ละแม": "Lamae",
    "พะโต๊ะ": "Pathio Ta",
    "สวี": "Sawi",
    "ทุ่งตะโก": "Thung Tako"
  },
  "Songkhla": {
    "เมืองสงขลา": "Mueang Songkhla",
    "สทิงพระ": "Sathing Phra",
    "จะนะ": "Chana",
    "นาทวี": "Na Thawi",
    "เทพา": "Thepha",
    "สะบ้าย้อย": "Saba Yoi",
    "ระโนด": "Ranot",
    "กระแสสินธุ์": "Krasae Sin",
    "รัตภูมิ": "Rattaphum",
    "สะเดา": "Sadao",
    "หาดใหญ่": "Hat Yai",
    "นาหม่อม": "Na Mom",
    "ควนเนียง": "Khuan Niang",
    "บางกล่ำ": "Bang Klam",
    "สิงหนคร": "Singhanakhon",
    "คลองหอยโข่ง": "Khlong Hoi Khong",
    "ท้องถิ่นเทศบาลตำบลสำนักขาม": "Sankham Municipal"
  },
  "Satun": {
    "เมืองสตูล": "Mueang Satun",
    "ควนโดน": "Khuan Don",
    "ควนกาหลง": "Khuan Kalong",
    "ท่าแพ": "Tha Phae",
    "ละงู": "La-ngu",
    "ทุ่งหว้า": "Thung Wa",
    "มะนัง": "Manang"
  },
  "Trang": {
    "เมืองตรัง": "Mueang Trang",
    "กันตัง": "Kantang",
    "ย่านตาขาว": "Yan Ta Khao",
    "ปะเหลียน": "Palian",
    "สิเกา": "Sikao",
    "ห้วยยอด": "Huai Yot",
    "วังวิเศษ": "Wang Wiset",
    "นาโยง": "Na Yong",
    "รัษฎา": "Ratsada",
    "หาดสำราญ": "Hat Samran"
  },
  "Phatthalung": {
    "เมืองพัทลุง": "Mueang Phatthalung",
    "กงหรา": "Kong Ra",
    "เขาชัยสน": "Khao Chaison",
    "ตะโหมด": "Tamot",
    "ควนขนุน": "Khuan Khanun",
    "ปากพะยูน": "Pak Phayun",
    "ศรีบรรพต": "Si Banphot",
    "ป่าบอน": "Pa Bon",
    "บางแก้ว": "Bang Kaeo",
    "ป่าพะยอม": "Pa Phayom",
    "ศรีนครินทร์": "Si Nakhon Khiri"
  },
  "Pattani": {
    "เมืองปัตตานี": "Mueang Pattani",
    "โคกโพธิ์": "Khok Pho",
    "หนองจิก": "Nong Chik",
    "ปะนาเระ": "Panare",
    "มายอ": "Mayo",
    "ทุ่งยางแดง": "Thung Yang Daeng",
    "สายบุรี": "Sai Buri",
    "ไม้แก่น": "Mai Kaen",
    "ยะหริ่ง": "Yaring",
    "ยะรัง": "Yarang",
    "กะพ้อ": "Kapho",
    "แม่ลาน": "Mae Lan"
  },
  "Yala": {
    "เมืองยะลา": "Mueang Yala",
    "เบตง": "Betong",
    "บันนังสตา": "Bannang Sata",
    "ธารโต": "Thanto",
    "ยะหา": "Yaha",
    "รามัน": "Raman",
    "กาบัง": "Kabong",
    "กรงปินัง": "Krong Pinang"
  },
  "Narathiwat": {
    "เมืองนราธิวาส": "Mueang Narathiwat",
    "ตากใบ": "Tak Bai",
    "บาเจาะ": "Bacho",
    "ยี่งอ": "Yi-ngo",
    "ระแงะ": "Ra-ngae",
    "รือเสาะ": "Rueso",
    "ศรีสาคร": "Si Sakhon",
    "แว้ง": "Waeng",
    "สุคิริน": "Sukhirin",
    "สุไหงโก-ลก": "Su-ngai Kolok",
    "สุไหงปาดี": "Su-ngai Padi",
    "จะแนะ": "Chanae",
    "เจาะไอร้อง": "Cho-airong"
  }
};
export default districts;
